import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');
	const torus = geo.createNode('torus');

	// add a light
	root.createNode('hemisphereLight');

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [torus],
		autoLayout: true,
	};
}
// export const sopTorus = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/sop/torus`,
// 		createData,
// 		relatedNodes: [TorusSopNode],
// 	}),
// ];
